module.exports = __webpack_public_path__ + "img/47.28299b2d.jpg";